module.exports = __webpack_public_path__ + "static/img/11.9a27182.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/sp/11.png
// module id = V14b
// module chunks = 0